import type { PlanCommercialFeature } from "@/types/plan";

export type CommercialModality = "companies" | "food";

export function commercialModality(segment: string | string[] | undefined): CommercialModality {
  return segment === "food" ? "food" : "companies";
}

// Presentation only: the legacy API identifies FOOD copy by this explicit prefix.
// Never infer entitlements from these descriptions or remove persisted features.
export function commercialFeatureModality(feature: PlanCommercialFeature): CommercialModality {
  return /^\s*food\s*:/i.test(feature.name) ? "food" : "companies";
}

export function moveCompanyCommercialFeature<T extends PlanCommercialFeature>(features: T[], index: number, direction: -1 | 1): T[] {
  const visible = features.filter(feature => commercialFeatureModality(feature) === "companies");
  const target = index + direction;
  if (index < 0 || index >= visible.length || target < 0 || target >= visible.length) return features;
  [visible[index], visible[target]] = [visible[target], visible[index]];
  let cursor = 0;
  // Send every ID required by the legacy API while keeping hidden FOOD slots.
  return features.map(feature => commercialFeatureModality(feature) === "companies" ? visible[cursor++] : feature);
}
